// Whether this page view should be counted.
//
// public/index.html makes the call and sets window.__PMG_ANALYTICS__, so the
// host list lives in exactly one place. The fallback repeats the check for the
// case where that inline script did not run (a test renderer, say).
//
// The check is an allowlist of production hostnames rather than a denylist of
// staging ones, so every non-production origin — the staging site, Netlify
// deploy previews, localhost — is excluded automatically, including ones that
// do not exist yet.
const PRODUCTION_HOSTS = ["www.partneredmg.com", "partneredmg.com"];

export const analyticsEnabled = () => {
    if (typeof window === "undefined") return false;
    if (typeof window.__PMG_ANALYTICS__ === "boolean") return window.__PMG_ANALYTICS__;
    return PRODUCTION_HOSTS.indexOf(window.location.hostname) !== -1;
};
